export function nameValidator(input) {
  const regName = /^[A-Za-z]\S{0,14}$/i;
  if (regName.test(input)) {
    return 1;
  }
  return -1;
}
